<template>
    <v-row>
        <v-col cols="6">
            <PER_Employees @selection-changed="handleSelectionChanged" />
        </v-col>
        <v-col cols="6">
            <PER_EmployeesDetails  v-if="selectedEmpId"
        :employee-id="selectedEmpId"
        :employee-row="selectedRow" />
        </v-col>
    </v-row>
</template>

<script lang="ts">
import PER_Employees from './PER_Employees.vue';
import PER_EmployeesDetails from './PER_EmployeesDetails.vue';

export default {
    components: {
        PER_Employees,
        PER_EmployeesDetails

    },
    data() {
        return {
            selectedEmpId: null as string | null,
            selectedRow: null as any,

        };
    },
    methods: {
        handleSelectionChanged(payload: any) {
      this.selectedEmpId = payload.empId
      this.selectedRow = payload.row
    }

    },
};
</script>

<style scoped>

</style>
